import { Button } from 'primereact/button'
import { PlanActionBarConfig } from '../hooks/usePlanPage'

const PlanActionBar = ({
  onSimulate,
  onExcelReload,
  onExcelOverwrite,
  onAdjustSettings,
  onCompare,
  isSimulatePending,
  isExcelPending,
  isExcelReloading,
  disableExcelReload,
  disableExcelOverwrite,
}: PlanActionBarConfig) => {
  return (
    <div className="flex flex-row flex-wrap justify-between px-2 gap-2 py-3">
      <Button
        icon="pi pi-sync"
        label="最適化の再実行"
        onClick={onSimulate}
        loading={isSimulatePending}
      />
      <Button
        icon="pi pi-chart-bar"
        label="計画の比較"
        severity="help"
        onClick={onCompare}
      />
      <Button
        icon="pi pi-sliders-h"
        label="範囲・設定を変更"
        severity="secondary"
        onClick={onAdjustSettings}
      />
      <Button
        severity="info"
        icon="pi pi-refresh"
        label="Excelファイルから再読み込み"
        onClick={onExcelReload}
        loading={isExcelReloading}
        disabled={disableExcelReload}
      />
      <Button
        severity="success"
        icon="pi pi-file-excel"
        label="Excelファイルに保存"
        onClick={onExcelOverwrite}
        loading={isExcelPending}
        disabled={disableExcelOverwrite}
      />
    </div>
  )
}

export default PlanActionBar
